module.exports = __webpack_public_path__ + "static/design-kits-07185f9eda27d5ed8eeb41c8eff0073c.jpg";